import {
  Component,
  ComponentRef,
  HostListener,
  Type,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { Modal } from '@shared/modal-service/models/modal.model';
import {
  DEFAULT_MODAL_OPTIONS,
  ModalOptions,
} from '../models/modal-options.model';

@Component({
  templateUrl: './modal-container.component.html',
  styleUrls: ['./modal-container.component.scss'],
  standalone: false,
})
export class ModalContainerComponent {
  @ViewChild('modalContainer', { read: ViewContainerRef })
  private modalContainer: ViewContainerRef;
  private ref: ComponentRef<Modal>;
  public options: ModalOptions = DEFAULT_MODAL_OPTIONS;

  constructor() {}

  @HostListener('document:keydown.escape')
  onEscapeKeyPressed(): boolean {
    if (this.options.dismissOnEscape) {
      this.ref.instance.dismiss();
      return false;
    }
  }

  @HostListener('document:keydown.enter')
  onEnterKeyPressed(): boolean {
    if (this.options.acceptOnEnter) {
      this.ref.instance.accept();
      return false;
    }
  }

  createModal<T extends Modal>(
    component: Type<T>,
    _options: ModalOptions
  ): ComponentRef<T> {
    this.options = { ...DEFAULT_MODAL_OPTIONS, ..._options };

    this.modalContainer.clear();
    this.ref = this.modalContainer.createComponent(component, { index: 0 });
    this.ref.location.nativeElement.classList.add('modal');

    if (this.options.id) {
      this.ref.location.nativeElement.id = this.options.id;
    }

    if (this.options.centered) {
      this.ref.location.nativeElement.classList.add(
        'modal-centered',
        'appear-centered'
      );
    } else {
      this.ref.location.nativeElement.classList.add('appear');
    }

    if (this.options.classNames) {
      if (Array.isArray(this.options.classNames)) {
        this.ref.location.nativeElement.classList.add(
          ...this.options.classNames
        );
      } else {
        this.ref.location.nativeElement.classList.add(this.options.classNames);
      }
    }

    return this.ref as ComponentRef<T>;
  }

  onBackdropClick(): void {
    if (this.options.backdrop && this.options.backdrop.dismissOnClick) {
      this.ref.instance.dismiss();
    }
  }
}
